import { UserCallAvailability } from "@redotech/redo-model/support/voice/voice-types";
import * as z from "zod/v4";

export const getTeamCallAvailabilities = {
  name: "getTeamCallAvailabilities" as const,
  input: z.object({}),
  output: z.object({
    callAvailabilities: z.array(
      z.object({
        userId: z.string(),
        availability: z.enum(UserCallAvailability),
      }),
    ),
  }),
};
